// extracted by mini-css-extract-plugin
export default {"enemyTarget":"EnemyTargetView_enemyTarget__Zk3He","avatar":"EnemyTargetView_avatar__qVa+p"};